module.exports = __webpack_public_path__ + "img/screen8.b38d4c4.png";